import React from 'react';
import '../App.css'

class Experience extends React.Component {

    render() {
      return (
        <div className="experience">
          <div className='linkedin_container'>
            <h1>Experience</h1>
          
          
            {this.props.data.map((value, i) => {
              return (<div style={{textAlign:'left', marginLeft:'1em', marginBottom:'1em', marginRight:'1em'}}>
                <b>{value.organization}</b><span style={{float:'right'}}>{value.location}</span>
                <div className="custom_break"></div>
                <i>{value.position}</i><span style={{float:'right'}}>{value.start_date} - {value.end_date}</span>
                <div className="custom_break"></div>
                <uo>
                  {value.description.map((item, j) => {
                    return <li>{item}</li>
                  })}
                </uo>
                </div>
                
              )
            })}
          </div>
        </div>
      )
    }
}

export default Experience;